<template>
    <div class="d-flex align-content-center flex-fill size-fijo">
        <router-link
            :to="{ name: this.route, params: { event_id: this.event_id, sesion_id: this.sesion_id, tipo_venta: this.tipo_venta } }"
            class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
        >
            <span>
                <span>{{ this.title }}</span>
                <small class="d-block" v-if="this.subtitle">{{ this.subtitle }}</small>
            </span>
        </router-link>
    </div>
</template>

<script>
    export default {
        props: ["title", "subtitle", "route", "event_id", "sesion_id", "tipo_venta"],
        name: "GoToCheckoutButton",
    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .size-fijo {
            width: 150px !important;
        }
    }
</style>